import {
  ThemeConfig,
  extendTheme,
  withDefaultColorScheme,
} from '@chakra-ui/react';

import { Breadcrumb } from './components/breadcrumb';
import { Button } from './components/button';
import { Form } from './components/form';
import { FormLabel } from './components/formLabel';
import { Heading } from './components/heading';
import { Input } from './components/input';
import { Link } from './components/link';
import { Menu } from './components/menu';
import { Modal } from './components/modal';
import { PinInput } from './components/pinInput';
import { Radio } from './components/radio';
import { Table } from './components/table';
import { Tabs } from './components/tabs';
import { Text } from './components/text';
import { Textarea } from './components/textarea';
import foundations from './foundations';
import { styles } from './styles';
const config: ThemeConfig = {
  initialColorMode: 'light',
  useSystemColorMode: false,
};

export const MyCustomTheme = extendTheme(
  {
    config,
    ...foundations,
    fonts: {
      heading: `var(--font-heading) !important`,
      body: `var(--font-body) !important`,
    },
    styles,
    components: {
      Breadcrumb,
      Button,
      Form,
      FormLabel,
      Heading,
      Input,
      Link,
      Menu,
      Modal,
      Select: Input,
      PinInput,
      Radio,
      Tabs,
      Textarea,
      Text,
      Table,
    },
    semanticTokens: {
      colors: {
        // Background
        'bg.primary': {
          default: 'white',
          _dark: foundations.colors.gray[900],
        },
        'bg.secondary': {
          default: foundations.colors.gray[100],
          _dark: foundations.colors.gray[800],
        },
        'bg.surface': {
          default: 'white',
          _dark: foundations.colors.gray[700],
        },
        'bg.main': {
          default: foundations.colors.gray[50],
          _dark: foundations.colors.gray[900],
        },
        'bg.table': {
          default: foundations.colors.gray[50],
          _dark: foundations.colors.gray[800],
        },
        'bg.disabled': {
          default: foundations.colors.gray[100],
          _dark: foundations.colors.gray[600],
        },

        // Text
        'text.primary': {
          default: foundations.colors.gray[700],
          _dark: 'whiteAlpha.900',
        },
        'text.secondary': {
          default: foundations.colors.gray[500],
          _dark: foundations.colors.gray[300],
        },
        'text.muted': {
          default: foundations.colors.gray[400],
          _dark: foundations.colors.gray[500],
        },
        'text.active': {
          default: foundations.colors.brand[900],
          _dark: foundations.colors.brand[600],
        },
        'text.error': {
          default: foundations.colors.error[500],
          _dark: foundations.colors.error[400],
        },

        // Border
        'border.primary': {
          default: foundations.colors.gray[200],
          _dark: foundations.colors.gray[800],
        },
        'border.muted': {
          default: foundations.colors.gray[100],
          _dark: foundations.colors.gray[700],
        },
        'border.table': {
          default: foundations.colors.gray[200],
          _dark: foundations.colors.gray[700],
        },

        // Accent (Primary Blue Theme)
        accent: {
          default: foundations.colors.brand[300],
          _dark: foundations.colors.brand[800],
        },
        'accent.hover': {
          default: foundations.colors.blue[700],
          _dark: foundations.colors.blue[400],
        },
        'accent.subtle': {
          default: foundations.colors.brand[100],
          _dark: foundations.colors.gray[800],
        },
        'accent.danger': {
          default: foundations.colors.error[100],
          _dark: foundations.colors.gray[800],
        },
        'accent.soft': {
          default: foundations.colors.brand[25],
          _dark: foundations.colors.brand[100],
        },

        // Button
        'button.primary': {
          default: foundations.colors.brand[500],
          _dark: foundations.colors.brand[600],
        },

        'button.edit': {
          default: foundations.colors.warning[500],
          _dark: foundations.colors.warning[300],
        },
        'button.acc': {
          default: foundations.colors.blue[500],
          _dark: foundations.colors.blue[300],
        },
        'button.reject': {
          default: foundations.colors.red[500],
          _dark: foundations.colors.red[300],
        },

        'button.delete': {
          default: foundations.colors.red[500],
          _dark: foundations.colors.red[300],
        },

        'button.detail': {
          default: foundations.colors.blue[400],
          _dark: foundations.colors.blue[300],
        },

        'button.disabled': {
          default: foundations.colors.gray[200],
          _dark: foundations.colors.gray[600],
        },
      },
    },
  },
  withDefaultColorScheme({ colorScheme: 'blue' }),
);
